import { createRoot } from "react-dom/client";
import styles from "./index.module.scss";

export interface CertificationModalProps {
  shareKey: string;
  onClose?: () => void;
}

type CertificationModalComponent = ((
  props: CertificationModalProps
) => JSX.Element) & {
  show: (shareKey: string) => void;
};
const CertificationModal: CertificationModalComponent = ({
  shareKey,
  onClose,
}) => {
  return (
    <div className={styles.certificationModal}>
      <div className={styles.mask} onClick={onClose} />
      <div className={styles.main}>
        <img
          src={`https://edu.py2fun.com/wiki-dynamic/api/certificate/${shareKey}`}
          alt=""
        />
      </div>
      <div className={styles.tips}>鼠标右键保存学习证书</div>
    </div>
  );
};

CertificationModal.show = (shareKey) => {
  const div = document.createElement("div");
  document.body.appendChild(div);
  const root = createRoot(div);

  const handleClose = () => {
    root.unmount();
    document.body.removeChild(div);
  };
  root.render(<CertificationModal shareKey={shareKey} onClose={handleClose} />);
};

export default CertificationModal;
